import React from "react";
import "./Style/Legends.scss"; // Styles specific to the Legends component
import { LEGENDS } from "./Constant"; // List of legend items (icon + label)

const Legends = () => {
  return (
    <div className="legends">
      {/* Section Title */}
      <p className="section-title">LEGEND:</p>
      <div className="d-flex">
        {LEGENDS.map((item, index) => (
          <div key={index} className="legend-name ml-2">
            {/* Icon Image */}
            <img src={item.icon} />
            {/* Legend Label */}
            <span className="label ml-1">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legends;
